import { InputNumber } from "antd";

const defaultRender = (value) => (value ? value : "--");

const columns = (setData) => [
    {
        title: "Employee Name",
        dataIndex: "name",
        render: defaultRender,
    },
    {
        title: "Email",
        dataIndex: "email",
        render: defaultRender,
    },
    {
        title: "Hours",
        dataIndex: "hours",
        render: defaultRender,

    },
    {
        title: "Overtime Hours(if any)",
        dataIndex: "overtime_hour",
        render: defaultRender,

    },
    {
        title: "Statutory Holiday(if any)",
        dataIndex: "holidays",
        render: defaultRender,

    },
    {
        title: "Rate",
        dataIndex: "rate",
        render: defaultRender,

    },
];

export default columns;
